import { useState } from "react";
import { TENANT_DOMAIN } from "../../../utils/domain";
import { ERROR_MESSAGES } from "../../../constant/constant";
import { useAxios } from "../../../utils/useAxios";

/**
 * @typedef {object} TeacherData
 * @property {string} [first_name]
 * @property {string} [last_name]
 * @property {string} [email]
 */

/**
 * This useUpdateTeacher hook is used to update a teacher's details.
 */
export const useUpdateTeacher = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const { axiosInstance } = useAxios();

  /**
   * @param {object} params
   * @param {string} params.teacherId
   * @param {TeacherData} params.updatedData
   * @param {()=> void} params.onSuccess
   * @returns
   */
  const updateTeacher = async ({ teacherId, updatedData, onSuccess }) => {
    try {
      setLoading(true);
      setError("");
      const response = await axiosInstance.put(
        `${TENANT_DOMAIN}/school/admin/teacher/update/${teacherId}`,
        updatedData,
      );
      onSuccess();
    } catch (error) {
      if (error?.status === 500) {
        setError(ERROR_MESSAGES.INTERNAL_SERVER);
      } else {
        setError(error?.response?.data?.message || ERROR_MESSAGES.UNKNOWN);
      }
    } finally {
      setLoading(false);
    }
  };

  return { updateTeacher, loading, error };
};

